import { Component, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild, Inject, ViewChildren, AfterViewInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { APP_CONFIG } from '../../../../../../src/app/config/app-config.module';
import { AppConfig } from '../../../../../../src/app/core/config-models/app-config.model';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { RouteURL } from '../../../../shared/enums';
import * as mobileSubmitActions from '../../actions';
import { IntlTelInputDirective } from '../../../../shared/intl-tel-input.directive';
import { SharedService } from '../../../../shared/shared.service';


@Component({
  selector: 'app-mobile-submit',
  templateUrl: './mobile-submit.component.html',
  styleUrls: ['./mobile-submit.component.css']
})
export class MobileSubmitComponent implements OnInit, AfterViewInit {
  fpSubmitMobileForm: UntypedFormGroup;
  @ViewChildren(IntlTelInputDirective) dirs;
  subdomain: string;

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private store: Store,
    private sharedService: SharedService,
    @Inject(APP_CONFIG) private appConfig: AppConfig
  ) {
    this.subdomain = this.sharedService.getSubDomain();
  }

  ngOnInit(): void {

    this.fpSubmitMobileForm = this.fb.group({
      phone: new UntypedFormControl(undefined, [Validators.required])
    });
    const dialCode = this.sharedService.forgotPasscodeDialingCode;
    const mobileNumber = this.sharedService.forgotPasscodeMobileNumber;
    if (dialCode && mobileNumber) {
      this.fpSubmitMobileForm.patchValue({ phone: mobileNumber });
    }


  }

  ngAfterViewInit(): void {
    const dialCode = this.sharedService.forgotPasscodeDialingCode;
    const mobileNumber = this.sharedService.forgotPasscodeMobileNumber;
    if (dialCode && mobileNumber && this.dirs?.first?.itiInstance) {
      setTimeout(() => {
        const fullNumber = dialCode + mobileNumber.replace(/\D/g, '');
        this.dirs.first.itiInstance.setNumber(fullNumber);
        this.fpSubmitMobileForm.patchValue({ phone: mobileNumber });
      }, 0);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnDestroy(): void {
  }

  onSubmitMobileClick(){
    const countryData = this.dirs.first.iti.getSelectedCountryData();
    this.sharedService.forgotPasscodeDialingCode = '+' + countryData.dialCode;
    this.sharedService.forgotPasscodeMobileNumber = this.fpSubmitMobileForm.value.phone;
    var request = {
      dialingCode: '+' + countryData.dialCode,
      mobileNumber: this.fpSubmitMobileForm.value.phone
    };
    this.store.dispatch(mobileSubmitActions.fromValidateMobileNumberActions.validateMobileNumberRequest({request:request}));
  }

  navSubmitMobileBackBtn() {
    this.router.navigateByUrl('/auth/sign-up');
  }
}
